import { action } from 'satcheljs';
export var addSuggestionPillInternal = action('ADD_SUGGESTION_PILL_INTERNAL', function (suggestionPill) { return ({ suggestionPill: suggestionPill }); });
export var autocompleteGhostText = action('AUTOCOMPLETE_GHOST_TEXT', function (cursorPosition, keyUsed) { return ({
    cursorPosition: cursorPosition,
    keyUsed: keyUsed,
}); });
export var onBackspacePressedSearchInput = action('ON_BACKSPACE_PRESSED_SEARCH_INPUT');
export var onDownArrowPressedSearchInput = action('ON_DOWN_ARROW_PRESSED_SEARCH_INPUT');
export var onEnterPressedSearchInput = action('ON_ENTER_PRESSED_SEARCH_INPUT', function (selectedSuggestionIndex) { return ({
    selectedSuggestionIndex: selectedSuggestionIndex,
}); });
export var onSearchInputFocused = action('ON_SEARCH_INPUT_FOCUSED');
export var onUpArrowPressedSearchInput = action('ON_UP_ARROW_PRESSED_SEARCH_INPUT');
export var removeSuggestionPillFromSearchBox = action('REMOVE_SUGGESTION_PILL_FROM_SEARCHBOX', function (suggestionPillId) { return ({
    suggestionPillId: suggestionPillId,
}); });
export var removeSuggestionPillFromStore = action('REMOVE_SUGGESTION_PILL_FROM_STORE', function (suggestionPillId, suggestionPillIndex) { return ({
    suggestionPillId: suggestionPillId,
    suggestionPillIndex: suggestionPillIndex,
}); });
export var resetSearchStore = action('RESET_SEARCH_STORE');
export var setIsUsing3S = action('SET_IS_USING_3S', function (isUsing3S) { return ({
    isUsing3S: isUsing3S,
}); });
export var setSearchText = action('SET_SEARCH_TEXT', function (searchText) { return ({
    searchText: searchText,
}); });
export var setSearchTextForSuggestion = action('SET_SEARCH_TEXT_FOR_SUGGESTION', function (searchTextForSuggestion) { return ({
    searchTextForSuggestion: searchTextForSuggestion,
}); });
export var setSelectedSuggestionIndex = action('SET_SELECTED_SUGGESTION_INDEX', function (selectedSuggestionIndex) { return ({
    selectedSuggestionIndex: selectedSuggestionIndex,
}); });
export var setSuggestionPillIds = action('SET_SUGGESTION_PILL_IDS', function (suggestionPillIds) { return ({
    suggestionPillIds: suggestionPillIds,
}); });
export var setSuggestionPills = action('SET_SUGGESTION_PILLS', function (suggestionPills) { return ({
    suggestionPills: suggestionPills,
}); });
export var updateGhostText = action('UPDATE_GHOST_TEXT');
export var updateIsSuggestionSetCompleteInternal = action('UPDATE_IS_SUGGESTION_SET_COMPLETE_INTERNAL', function (isComplete) { return ({
    isComplete: isComplete,
}); });
//# sourceMappingURL=internalActions.js.map